import React from 'react';
import { Input } from 'antd';
import { TI18nText } from '../../../models/courses/graphicDesign';

export type TAdminLanguage = 'fr' | 'en' | 'ar';
interface Props { value?: TI18nText; onChange: (next: TI18nText) => void;
  language: TAdminLanguage; multiline?: boolean; readOnly?: boolean;
  placeholder?: string; 'aria-label'?: string }
const LocalizedInput: React.FC<Props> = ({ value, onChange, language, multiline,
  readOnly, placeholder, 'aria-label': ariaLabel }) => {
  const shared = { value: value?.[language] ?? '', disabled: readOnly,
    dir: language === 'ar' ? 'rtl' as const : 'ltr' as const,
    placeholder: language !== 'fr' && !value?.[language] ? value?.fr : placeholder,
    'aria-label': ariaLabel,
    onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      onChange({ fr: value?.fr ?? '', ...value, [language]: event.target.value }) };
  return multiline ? <Input.TextArea {...shared} autoSize={{ minRows: 2, maxRows: 6 }} />
    : <Input {...shared} />;
};
export default LocalizedInput;
